// extracted by mini-css-extract-plugin
export default {"mainBtn":"Button_mainBtn__CAP9h","inverseBtn":"Button_inverseBtn__oHytn"};